// extracted by mini-css-extract-plugin
module.exports = {"root":"zgrOZ7sM","leftWrapper":"w3uBCAHi","rightWrapper":"VZM837Vy"};